import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

Meta.propTypes = {
    title:PropTypes.string,
    description:PropTypes.string,
    is404:PropTypes.bool,
    canonicalUrl:PropTypes.string //no incluir Host
};

function Meta({title, description, is404=false, canonicalUrl="", ...props}) {
    //const host = process.env.REACT_APP_HOST;
    return (
        <>
        <Helmet>
            {is404 ? <meta name="robots" content="noindex"></meta> : <meta name="robots" content="index, follow" />}
            <title>{title}</title>
            <meta name='description' content={description}/>            
            {/*<link rel="canonical" href={host+canonicalUrl} />*/}
        </Helmet>
        </>
    );
}

export default Meta;